

module.exports = __webpack_require__.stylable.create(
    "RadioButtonGroup1967884220",
    {"classes":{"root":"RadioButtonGroup1967884220__root","wrapper":"RadioButtonGroup1967884220__wrapper","label":"RadioButtonGroup1967884220__label","error":"RadioButtonGroup1967884220__error"},"vars":{},"stVars":{"DefaultLabelColor":"color-5","DisabledColor":"color-3","Font":"\"font({theme: 'Body-M', size: '14px', lineHeight: '1.5em'})\"","FontError":"\"font({theme: 'Body-M', size: '12px', lineHeight: '1.75em'})\"","LabelColor":"--overridable","CurrentLabelColor":"\"color(fallback(--overridable, color-5))\""},"keyframes":{}},
    "",
    2,
    "RadioButtonGroup1967884220",
    null
);
